import {generateArrivalsReport} from "./ApiTasks";
import {DownloadFile} from "./DownloadFile";

export const DownloadArrivalsReport = async () => {

    let report = {};
    report.errorDescription = undefined;
    try {
        report = await generateArrivalsReport();
    } catch (error) {
        console.error('Could not generate arrivals report ', error);
        return;
    }

    if (report?.errorDescription) {
        throw new Error(report.errorDescription === "No results found" ?  report.errorDescription : "Could not generate report");
    }

    await DownloadFile(report.document.filename, report.document.file);
}
